<div class="restricoes">
  <!-- <div>
    <div class="item-switch">
      <img src="assets/images/switch-on.png" alt="icone-produto">
      <p>Produto não liberado para consumo.</p>
    </div>
    <div class="item-switch">
        <img src="assets/images/switch-off.png" alt="icone-produto">
        <p>Produto liberado para consumo.</p>
      </div>
  </div> -->

  <ul>
    <li *ngFor="let category of categories" (click)="goToSingle(category.id)">
      <div class="itens-extract">
        <!-- <img src="assets/images/copo.png" alt="icone-produto"> -->
        <h2>{{ category.name }}</h2>
      </div>
      <img src="assets/images/arrow.png" width="10px">
    </li>
    <li *ngIf="categories.length == 0">
      <div class="itens-extract">
        <h2>Não há categorias cadastradas</h2>
      </div>
    </li>
  </ul>
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/restriction/restriction.component.html